<div class="app-container d-flex">
  <div class="sidebar-wrapper" [class.collapsed]="isSidebarCollapsed">
    <app-sidebar (sidebarToggled)="updateCollapseValue($event)"></app-sidebar>
  </div>

  <div class="main-content">
    <app-navbar [isCollapsed]="isSidebarCollapsed" [IsMobileView]="isMobileView" (sidebarToggled)="updateCollapseValue($event)"></app-navbar>

    <div class="content-area" [class.loading]="loading$ | async">
      
      <!-- Spinner now inside content-area -->
      <div *ngIf="loading$ | async" class="main-content-loader">
        <div class="spinner"></div>
      </div>

      <router-outlet></router-outlet>
    </div>
  </div>
</div>
